import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  CreateCandidacyMutation as CreateCandidacyMutationType,
  CreateCandidacyMutationVariables,
} from "./__generated__/CreateCandidacyMutation";

const CreateCandidacyMutation = loader("./CreateCandidacyMutation.gql");

type CreateCandidacyMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError: (error: ApolloError) => void;
  onCompleted: (data: CreateCandidacyMutationType) => void;
}) => ReactElement;

export const CreateCandidacyMutationProvider: CreateCandidacyMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<CreateCandidacyMutationType, CreateCandidacyMutationVariables>(
    CreateCandidacyMutation,
    {
      errorPolicy: "none",
      onError,
      onCompleted,
    },
  );

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
